import authReducer from './slices/authSlice';
import { configureStore } from '@reduxjs/toolkit';
import clientsReducer from './slices/clientsSlice';
import langReducer from './slices/langSlice';
import representativesReducer from './slices/representativesSlice';
import invoiceReducer from './slices/invoiceSlice';
import productReducer from './slices/productSlice';
import categoryReducer from './slices/categorySlice';
import tripReducer from './slices/tripSlice';
import routesReducer from './slices/routesSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    clients: clientsReducer,
    lang: langReducer,
    representatives: representativesReducer,
    invoices: invoiceReducer,
    products: productReducer,
    categories: categoryReducer,
    trips: tripReducer,
    routes: routesReducer,
  },
});

export default store;



